import { ca } from '@cian/analytics';

interface ITrackNavigationTListing {
  queryString: string;
}

export function trackNavigationToListing({ queryString }: ITrackNavigationTListing) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'to_listingjk',
    sc: queryString,
  });
}
